import React, { createContext, useCallback, useContext, useEffect } from 'react'
import { getUserId } from './AuthUtils'
import {
    setStorageUserTokenInfo,
    useAuthTokenInfo,
    useAuthTokenInfoCRUD,
} from './query-keys/AuthentionQueryManager'

export const AuthContext = createContext({})

const AuthProvider = React.memo(({children}) => {
    const {data} = useAuthTokenInfo(getUserId())
    const {mutate: updateAuthTokenInfo} = useAuthTokenInfoCRUD(getUserId())

    useEffect(() => {
        if (!!data?.id) {
            setStorageUserTokenInfo(data)
        }
    }, [data])

    const handleUpdateCurrentLoggedInUser = useCallback(userData => {
         updateAuthTokenInfo(userData)
        
    }, [])

    return (
        <AuthContext.Provider
            value={{
                // values
                isLoggedIn: !!data?.id,
                user: !!data?.id ? data : {},

                // actions
                updateCurrentLoggedInUser: handleUpdateCurrentLoggedInUser,
            }}>
            {children}
        </AuthContext.Provider>
    )
})

export const useAuth = () => useContext(AuthContext)
export default AuthProvider
